import {useState, useEffect} from "react";
import {Trans, useTranslation} from "react-i18next";
import {scrollIntoViewWithOffset} from "utils";
import {Button} from "../Button";

export function Timer({id, time, className, minutes, seconds}) {
  const {t} = useTranslation('common')

  const
    d = Math.floor(time / (24 * 60 * 60)),
    h = Math.floor((time % (24 * 60 * 60)) / (60 * 60)),
    m = Math.floor((time % (60 * 60)) / 60),
    s = time % 60,
    // hours = (h < 10 ? '0' : '') + h,
    hours = (Math.floor(time / (60 * 60)) < 10 ? '0' : '') + Math.floor(time / (60 * 60)),
    min = (m % 60 < 10 ? '0' : '') + (m % 60),
    // min = (Math.floor(time / 60) < 10 ? '0' : '') + Math.floor(time / 60),
    sec = (s < 10 ? '0' : '') + s

  if (minutes)
    return <b className={className} id={id}>{h > 0 ? hours : min}</b>
  else if (seconds)
    return <b className={className} id={id}>{h > 0 ? min : sec}</b>

  let dateStr

  if (h > 0) {
    dateStr = t('date', {d, h, m}).split('{{s}}')[0].trim()

    if (d <= 0) {
      const arr = dateStr.split(' ')
      arr.splice(0, 1)
      dateStr = arr.join(' ')
    }
  } else
    dateStr = `${min}:${sec}`

  return (
    <strong className={className} id={id}>{dateStr}</strong>
  )
}


export function TimerPanel({count, onTime, keyPrefix = 'paywall', onContinue}) {
  const
    {t} = useTranslation('common', {keyPrefix}),
    {t: t0} = useTranslation('common')

  const
    // A55 = getExperiment('A55', 'A'),
    // A77 =
    //   LandingEnum.default === window.landing && i18n.resolvedLanguage === 'en'
    //     ? getExperiment('A77')
    //     : {value: 'A'},
    [time, setTime] = useState(count)

  let timer

  useEffect(() => {
    timer = setInterval(() => {
      setTime(time => {
        onTime && onTime(time - 1)

        if (time <= 0) {
          // mixpanel.track('time is out')
          // onClose && onClose()

          // document.querySelectorAll('.reserved').forEach((item) => {
          //   item.style.display = 'none'
          // })
          // document.querySelector('.top').removeAttribute('style')

          clearInterval(timer)

          return time
        }

        return time - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  useEffect(() => {
    if (document.getElementById('time')) {
      document.querySelectorAll('.timing').forEach(function (el) {
        el.innerHTML = document.getElementById('time').innerHTML
      })

      let time = document.getElementById('time').innerHTML.split(':')

      if (time.length <= 1) {
        const arr = time[0].split('&nbsp;')

        if (arr.length > 2)
          time = [
            parseInt(arr[0]) * 24 + parseInt(arr[1]),
            parseInt(arr[2])
          ]
        else
          time = [
            parseInt(arr[0]),
            parseInt(arr[1])
          ]

        if (time[0] < 10)
          time[0] = '0' + time[0]

        if (time[1] < 10)
          time[1] = '0' + time[1]
      }

      document.querySelectorAll('.timing-min').forEach(function (el) {
        el.innerHTML = time[0]
      })
      document.querySelectorAll('.timing-sec').forEach(function (el) {
        el.innerHTML = time[1]
      })

      if (window.updateTime)
        window.updateTime(time)
    }
  }, [time])

  useEffect(() => {
    setTime(count)
  }, [count])

  // if (time <= 0)
  //   return true

  // const handleGetMyPlan = () => {
  //   scrollIntoViewWithOffset('#plan', 82)
  //   setTrack('paywall_cta_top_click')
  // }

  if (onContinue)
    return (
      <div className={'panel-timer'} style={{backgroundColor: 'rgba(1,3,11,.8)', padding: '.5rem 0'}}>
        <div className={'wrap px-2 text-center row'}>
          <p className='items gap-1 w-100'>
            <Trans i18nKey="expires" t={t}>
              <small>51% discount reserved for:</small> <Timer id={'time'} time={time}/>
            </Trans>
          </p>
          <Button variant={'white'} className={'w-auto'} onClick={onContinue}>
            {t0('continue')}
          </Button>
        </div>
      </div>
    )

  return (
    <div className={'panel-timer'} role={'button'}
         onClick={() => scrollIntoViewWithOffset('#plan', 58)}
    >
      <div className={'wrap px-2 text-center'}>
        <p>
          <Trans i18nKey="expires" t={t}>
            <em>Intro offer expires in:</em> <Timer id={'time'} time={time}/>
          </Trans>
        </p>
        {
          // A55.value === 'B' &&
          // <Button className={'w-auto'} onClick={handleGetMyPlan}>
          //   {t('getMyPlan.btn')}
          // </Button>
        }
      </div>
    </div>
  )
}